<!-- Nome Lista -->
<div class="ui-g-12">
  <label class="required">{{ 'campaign.listName' | translate }}</label>
  <input type="text" pInputText [(ngModel)]="listName">
</div>
<!-- Table Cluster Head -->
<div class="ui-g-12">
  <app-kontable
    #table
    id="gifts-table"
    title="Cluster Head"
    [columns]="[
      'headDescription',
      'clusterDescription',
      {field: 'date_start', title: 'common.date_start', type: 'date', filterType: dateFilter},
      {field: 'date_end', title: 'common.date_end', type: 'date', filterType: dateFilter}
    ]"
    [titles]="['common.name', 'common.description']"
    [service]="clusterHeadService"
    [paginationType]="paginationType"
    [showRecoverButton]="false"
    [showInfoButton]="false"
    [showAddButton]="false"
    [showDeleteButton]="false"
    [showDetailsButton]="false"
    [showEditButton]="false"
    [showReport]="false"
    [additionalRowCommands]="customRow"
  >
  <ng-template #customRow data-testid="customRow" let-row>
    <p-checkbox
      class="ch-checkbox"
      value="{{row.clusterHeadId}}"
      [(ngModel)]="selectedClusterHeads">
    </p-checkbox>
  </ng-template>
  </app-kontable>
</div>
<!-- Save -->
<div class="ui-g-12 text-right">
  <button
    pButton
    (click)="saveList()"
    type="button"
    class="k-generic-btn"
    label="{{ 'common.save' | translate }}"
    [disabled]="!listName || selectedClusterHeads.length === 0">
  </button>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/new-coupon-recipient-list/new-coupon-recipient-list.component.html